import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DateRangePicker,
  format_date,
  GET,
  PUT,
  DELETE,
  t,
  can,
} from "../../components/CustomComponent.js";
import { initials, avatarTone, lineAddUrl } from "../../components/people_option.js";
import { bankLabel, bankLogo } from "../../components/topup_option.js";
import { zoneOptions } from "../../components/location_option.js";
import {
  PARTNER_STATUSES,
  STATUS_TRANSITIONS,
  REASON_REQUIRED_STATUSES,
  EXPERIENCE_OPTIONS,
  EXPERTISE_OPTIONS,
  DOC_TYPES,
  SORTS,
  statusMeta,
  optionLabel,
  fmtPhone,
  fileSize,
  fullAddress,
  isImageDoc,
} from "../../components/partner_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/crm.css";
import "../../assets/css/partner_admin.css";

/* ============================================================================
 * พาร์ตเนอร์  (/ad/partners)
 *
 * คิวงานตรวจใบสมัครนายหน้าภายนอกที่ส่งเข้ามาจากหน้าเว็บสาธารณะ (/partner)
 *
 * หน้านี้ "ไม่มีปุ่มเพิ่ม" โดยตั้งใจ — ใบสมัครเกิดจากผู้สมัครเท่านั้น เพราะต้องผ่าน
 * การยืนยันอีเมลด้วย OTP และการกดยอมรับข้อกำหนด/PDPA ของตัวผู้สมัครเอง สองอย่างนี้
 * แอดมินกดแทนไม่ได้ (ความยินยอมที่คนอื่นกดแทนใช้เป็นฐานทางกฎหมายไม่ได้)
 *
 * สิ่งที่ทำได้ : กรอง-ค้นหา, ดูรายละเอียด+เอกสารยืนยันตัวตน, แก้ข้อมูลที่กรอกผิด,
 * รับเรื่อง/อนุมัติ/ไม่อนุมัติ/ระงับ/คืนสิทธิ์, ลบใบที่ยังไม่ได้อนุมัติ
 *
 * อนุมัติแล้ว = ระบบออกบัญชีเข้าใช้งานให้ในตาราง users (user_type = "partner")
 * พร้อมบทบาทระบบ "พาร์ตเนอร์" ผู้สมัครล็อกอินด้วยอีเมล + รหัสผ่านที่ตั้งไว้ตอนสมัคร
 * ได้ทันทีจากปุ่มเข้าสู่ระบบบนหน้าเว็บสาธารณะ
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/partners              รายการ + ตัวกรอง (page 0 = ทั้งหมด)
 *   GET    admin/partners/summary      การ์ดสรุป + ยอดของแต่ละสถานะ
 *   GET    admin/partners/:uid         รายละเอียด + เอกสารแนบ
 *   PUT    admin/partners/:uid         แก้ไขข้อมูลใบสมัคร (partners.update)
 *   PUT    admin/partners/:uid/review  เปลี่ยนสถานะ (partners.approve — สิทธิ์คนละข้อ)
 *   DELETE admin/partners/:uid         ลบใบที่ยังไม่ได้อนุมัติ (partners.delete)
 * ========================================================================== */

const PAGE_SIZE = 10;

const EMPTY_FILTER = {
  keyword: "",
  status: "",
  experience: "",
  doc_type: "",
  province: "",
  submitted: { start_date: null, end_date: null },
};

const EMPTY_SUMMARY = {
  total: 0,
  status: {},
  open: 0,
  approved: 0,
  approve_rate: 0,
  active: 0,
  suspended: 0,
};

/* ค่าเริ่มต้นของฟอร์มแก้ไข — คีย์วางให้ตรงกับ payload ที่ส่งให้ API
   ไม่มี email / status : อีเมลผ่าน OTP มาแล้วและเป็นชื่อผู้ใช้ของบัญชีที่ออกให้
   ส่วนสถานะต้องผ่านกล่อง "เปลี่ยนสถานะ" ซึ่งขอสิทธิ์คนละข้อ */
const EMPTY_FORM = {
  full_name: "",
  phone: "",
  line_id: "",
  address: "",
  province: "",
  district: "",
  subdistrict: "",
  postcode: "",
  bank: "",
  bank_account_no: "",
  bank_account_name: "",
  experience: "",
  license_no: "",
  expertise: [],
  about: "",
  note: "",
};

/* ค่าเริ่มต้นของกล่องตรวจสอบ — to ว่าง = ยังไม่ได้เลือกผล (ยังไม่เปิดช่องเหตุผล) */
const EMPTY_REVIEW = { to: "", reason: "" };

/* ใบที่ตัดสินผลไปแล้ว — แถวในตารางเหลือแค่ปุ่มดูรายละเอียด ไม่ต้องมีปุ่มตรวจสอบอีก */
const DECIDED_STATUSES = ["approved", "rejected"];

/* ---------------------------------------------------------------- ตัวช่วย */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
const dateText = (value) => (value ? format_date(value, "dd mmm yyyy", locale()) : "-");
const timeText = (value) => (value ? format_date(value, "hh:mm", locale()) : "-");
const dateTimeText = (value) => (value ? format_date(value, "dd mmm yyyy hh:mm", locale()) : "-");

/* ค่าที่ส่งให้ API เป็น YYYY-MM-DD เสมอ (สูตรเดียวกับหน้าลูกค้า) */
const toISODate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

/* ป้ายกำกับปุ่มเปลี่ยนสถานะ — คำที่ใช้บนปุ่มต่างจากชื่อสถานะ เพราะปุ่มคือ "การกระทำ"
   (อนุมัติ) ส่วนป้ายคือ "ผลลัพธ์" (อนุมัติแล้ว) tone = สีปุ่ม */
const ACTION_LABEL = {
  reviewing: { label: "partner_action_review", icon: "" },
  approved: { label: "partner_action_approve", icon: "" },
  rejected: { label: "partner_action_reject", icon: "" },
  suspended: { label: "partner_action_suspend", icon: "" },
  pending: { label: "partner_action_reopen", icon: "" },
};

/* คำอธิบายใต้ตัวเลือกในกล่องตรวจสอบ — บอกว่ากดแล้วเกิดอะไรขึ้นจริง ไม่ใช่แค่ชื่อสถานะ
   คนที่กดจึงไม่ต้องจำเองว่าอนุมัติแล้วระบบไปเปิดบัญชีให้ด้วยหรือเปล่า */
const PICK_HINT = {
  reviewing: "partner_pick_reviewing",
  approved: "partner_pick_approved",
  rejected: "partner_pick_rejected",
  suspended: "partner_pick_suspended",
  pending: "partner_pick_pending",
};

const pickHint = (from, to) =>
  from === "suspended" && to === "approved" ? "partner_pick_restore" : PICK_HINT[to] || "";

/* คืนสิทธิ์ใช้ปุ่มคำว่า "คืนสิทธิ์" ไม่ใช่ "อนุมัติ" — เป็นคนละการกระทำในสายตาผู้ใช้
   ทั้งที่สถานะปลายทางเดียวกัน (approved) */
const actionMeta = (from, to) =>
  from === "suspended" && to === "approved"
    ? { label: "partner_action_restore", icon: "" }
    : ACTION_LABEL[to] || { label: "partner_action_change", icon: "" };

export default class Partners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      count: 0,
      page: 1,
      sort: SORTS[0].value,
      summary: { ...EMPTY_SUMMARY },

      filter: { ...EMPTY_FILTER },
      applied: { ...EMPTY_FILTER },

      // ใบที่เปิดดูรายละเอียดอยู่ (โหลดใหม่ทุกครั้งที่เปิด เพราะเอกสารอาจเพิ่งอัปเดต)
      modal_view: false,
      detail: null,

      modal_form: false,
      edit_uid: "",
      form: { ...EMPTY_FORM },

      // กล่องตรวจสอบ — ใช้กล่องแยกแทน Swal เพราะต้องเห็นข้อมูลครบก่อนตัดสิน
      // และผลที่ต้องมีเหตุผลต้องมีที่ให้พิมพ์
      modal_review: false,
      review: { ...EMPTY_REVIEW },

      // เอกสารที่กดขยายดูเต็มจอ
      preview: null,
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* ------------------------------------------------------------ ดึงข้อมูล */

  /** พารามิเตอร์ที่ส่งขึ้น API — ตัดคีย์ที่ว่างทิ้งเพื่อไม่ให้ backend เห็นเป็นตัวกรอง */
  query = (page, filter, sort, extra = {}) => {
    const params = {
      page,
      page_size: PAGE_SIZE,
      sort,
      data_search: filter.keyword,
      status: filter.status,
      experience: filter.experience,
      doc_type: filter.doc_type,
      province: filter.province,
      submitted_start: toISODate(filter.submitted?.start_date),
      submitted_end: toISODate(filter.submitted?.end_date),
      ...extra,
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
    );
  };

  Get = async (page = 1, filter = this.state.filter, sort = this.state.sort) => {
    loading(true);
    // การ์ดสรุปใช้ตัวกรองชุดเดียวกับตาราง (ยกเว้นสถานะ ซึ่ง backend ตัดออกให้เอง)
    const [result, summary] = await Promise.all([
      GET("admin/partners", this.query(page, filter, sort)),
      GET("admin/partners/summary", this.query(0, filter, sort)),
    ]);
    loading(false);

    if (!result?.status) return;

    const rows = result.data || [];

    // ลบรายการสุดท้ายของหน้าแล้วหน้านั้นว่าง — ถอยไปหน้าก่อนหน้าให้อัตโนมัติ
    if (!rows.length && page > 1) return this.Get(page - 1, filter, sort);

    this.setState({
      data: rows,
      count: result.pagination?.count || 0,
      page,
      applied: { ...filter },
      sort,
      summary: summary?.status ? { ...EMPTY_SUMMARY, ...summary.data } : this.state.summary,
    });
  };

  /* -------------------------------------------------------------- ตัวกรอง */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  clearFilters = () => this.setState({ filter: { ...EMPTY_FILTER } }, () => this.Get(1, { ...EMPTY_FILTER }));

  /** คลิกป้ายสถานะบนแถบด้านบน = สลับกรองเฉพาะสถานะนั้น */
  toggleStatus = (value) => {
    const status = this.state.applied.status === value ? "" : value;
    const filter = { ...this.state.filter, status };
    this.setState({ filter }, () => this.Get(1, filter));
  };

  /* ------------------------------------------------------- ดูรายละเอียด */
  /* ยิงขอรายละเอียดใหม่เสมอแทนการใช้แถวในตาราง — โน้ตภายในและสถานะอาจถูกเปลี่ยน
     โดยแอดมินคนอื่นไปแล้วตั้งแต่ตอนที่ตารางโหลดมา */
  loadDetail = async (uid) => {
    loading(true);
    const result = await GET(`admin/partners/${uid}`);
    loading(false);

    return result?.status ? result.data : null;
  };

  OpenView = async (item) => {
    const detail = await this.loadDetail(item.uid);
    if (!detail) return;

    this.setState({ modal_view: true, detail });
  };

  CloseView = () => this.setState({ modal_view: false, detail: null, preview: null });

  /* ------------------------------------------------------------ แก้ไขข้อมูล */
  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      modal_view: false,
      edit_uid: item.uid,
      form: {
        full_name: item.full_name || "",
        phone: item.phone || "",
        line_id: item.line_id || "",
        address: item.address || "",
        province: item.province || "",
        district: item.district || "",
        subdistrict: item.subdistrict || "",
        postcode: item.postcode || "",
        bank: item.bank || "",
        bank_account_no: item.bank_account_no || "",
        bank_account_name: item.bank_account_name || "",
        experience: item.experience || "",
        license_no: item.license_no || "",
        expertise: [...(item.expertise || [])],
        about: item.about || "",
        note: item.note || "",
      },
    });

  CloseForm = () => this.setState({ modal_form: false, edit_uid: "" });

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* เปลี่ยนจังหวัด = เขต/แขวง/รหัสไปรษณีย์เดิมใช้ไม่ได้แล้ว ต้องล้างพร้อมกัน
     ไม่งั้นจะได้ที่อยู่ที่ผสมข้ามจังหวัดโดยผู้แก้ไม่ทันสังเกต (สูตรเดียวกับฟอร์มใบสมัคร) */
  setProvince = (province) => this.setForm({ province, district: "", subdistrict: "", postcode: "" });
  setDistrict = (district) => this.setForm({ district, subdistrict: "", postcode: "" });

  setSubdistrict = (value, option) => {
    // code ใน th_province.json คือรหัสไปรษณีย์ของแขวง/ตำบลนั้น — เติมให้เลย
    this.setForm({ subdistrict: value, postcode: option?.code ? String(option.code) : "" });
  };

  toggleExpertise = (value) => {
    const list = this.state.form.expertise || [];
    this.setForm({ expertise: list.includes(value) ? list.filter((item) => item !== value) : [...list, value] });
  };

  Save = async () => {
    const { form, edit_uid } = this.state;

    if (!form.full_name.trim()) return alert("", "warning", t("warning"), t("partner_verify_name"));
    if (form.phone && !/^0[689]\d{8}$/.test(form.phone))
      return alert("", "warning", t("warning"), t("partner_verify_phone"));
    if (form.postcode && !/^\d{5}$/.test(form.postcode))
      return alert("", "warning", t("warning"), t("partner_verify_postcode"));

    /* เลขบัญชีต้องตรวจก่อนส่ง ไม่ปล่อยให้ backend ตีกลับ — ข้อความจาก zod เป็นภาษาอังกฤษ
       และไม่ได้ชี้ว่าผิดที่ช่องไหน กติกาต้องตรงกับ update-partner.dto.js */
    const accountDigits = form.bank_account_no.replace(/[^0-9]/g, "");
    if (form.bank_account_no.trim() && (!/^[0-9][0-9\s-]*$/.test(form.bank_account_no.trim()) || accountDigits.length < 8 || accountDigits.length > 20))
      return alert("", "warning", t("warning"), t("partner_verify_account_no"));

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    /* ส่งเฉพาะช่องที่มีค่า — DTO ฝั่ง backend เป็น .strict() และช่องข้อความว่าง
       ถูก removeEmptyString ตัดทิ้งระหว่างทางอยู่แล้ว ส่งไปก็ไม่มีผล */
    const body = {
      full_name: form.full_name.trim(),
      phone: form.phone,
      line_id: form.line_id.trim(),
      address: form.address.trim(),
      province: form.province,
      district: form.district,
      subdistrict: form.subdistrict,
      postcode: form.postcode,
      bank: form.bank,
      bank_account_no: form.bank_account_no.trim(),
      bank_account_name: form.bank_account_name.trim(),
      experience: form.experience,
      license_no: form.license_no.trim(),
      expertise: form.expertise,
      about: form.about.trim(),
      note: form.note.trim(),
    };

    loading(true);
    const result = await PUT(`admin/partners/${edit_uid}`, body);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false, edit_uid: "" });
    await this.Get(this.state.page, this.state.applied);
    alert("", "success", t("success"), t("save_done"));
  };

  /* --------------------------------------------------------- ตรวจสอบใบสมัคร */
  /* กล่องแยกแทน Swal เพราะต้องเห็นข้อมูลกับเอกสารครบก่อนตัดสิน และผลที่ต้องมีเหตุผล
     (ไม่อนุมัติ / ระงับ) ต้องมีที่ให้พิมพ์เต็ม ๆ ไม่ใช่ช่องบรรทัดเดียว */
  OpenReview = async (item) => {
    const detail = await this.loadDetail(item.uid);
    if (!detail) return;

    this.setState({ modal_review: true, modal_view: false, detail, review: { ...EMPTY_REVIEW } });
  };

  CloseReview = () =>
    this.setState({ modal_review: false, detail: null, preview: null, review: { ...EMPTY_REVIEW } });

  setReview = (patch) => this.setState((prev) => ({ review: { ...prev.review, ...patch } }));

  Review = async (to) => {
    const { detail, review } = this.state;
    const needReason = REASON_REQUIRED_STATUSES.includes(to);
    const reason = (review.reason || "").trim();

    if (needReason && !reason) return alert("", "warning", t("warning"), t("partner_verify_reason"));

    const meta = actionMeta(detail.status, to);
    if (!(await alert("", "info", t(meta.label), t(`partner_confirm_${to}`), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT(`admin/partners/${detail.uid}/review`, {
      status: to,
      ...(needReason ? { reason } : {}),
    });
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_review: false, detail: null, preview: null, review: { ...EMPTY_REVIEW } });
    await this.Get(this.state.page, this.state.applied);
    alert("", "success", t("success"), t(`partner_result_${to}`));
  };

  /* ------------------------------------------------------------------- ลบ */
  /* backend กันไม่ให้ลบใบที่อนุมัติแล้วอีกชั้น — ที่นี่ซ่อนปุ่มไว้ก่อนเพื่อไม่ให้กด
     แล้วเจอข้อความปฏิเสธทั้งที่หน้าจอโชว์ปุ่มให้กด */
  Delete = async (item) => {
    const detail = `${t("partner_delete_desc")}\n${item.code} · ${item.full_name}`;
    if (!(await alert("", "warning", t("delete_item"), detail, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE(`admin/partners/${item.uid}`, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_view: false, detail: null });
    await this.Get(this.state.page, this.state.applied);
    alert("", "success", t("success"), t("delete_done"));
  };

  /* ================================================== render : การ์ดสรุป */
  renderSummary = () => {
    const s = this.state.summary;
    const cards = [
      { label: "partner_kpi_total", value: s.total, hint: "partner_kpi_total_hint", icon: "", color: "#4d7c0f", tint: "#eaf9d2" },
      { label: "partner_kpi_open", value: s.open, hint: "partner_kpi_open_hint", icon: "", color: "#b45309", tint: "#fef3c7" },
      { label: "partner_kpi_reviewing", value: s.status?.reviewing || 0, hint: "partner_kpi_reviewing_hint", icon: "", color: "#1d4ed8", tint: "#dbeafe" },
      { label: "partner_kpi_active", value: s.active, hint: `${t("partner_kpi_approve_rate")} ${s.approve_rate}%`, raw_hint: true, icon: "", color: "#15803d", tint: "#dcfce7" },
      { label: "partner_kpi_suspended", value: s.suspended, hint: "partner_kpi_suspended_hint", icon: "", color: "#57534e", tint: "#e7e5e4" },
      { label: "partner_kpi_rejected", value: s.status?.rejected || 0, hint: "partner_kpi_rejected_hint", icon: "", color: "#b91c1c", tint: "#fee2e2" },
    ];

    return (
      <div className="row g-3 mb-3">
        {cards.map((card, i) => (
          <div className="col-xl-2 col-lg-4 col-sm-6" key={i}>
            <div className="crm-stat prop-in">
              <span className="crm-stat__edge" style={{ backgroundColor: card.color }} />
              <span className="crm-stat__icon icon" style={{ backgroundColor: card.tint, color: card.color }}>
                {card.icon}
              </span>
              <div className="min-w-0">
                <div className="crm-stat__label text-truncate">{t(card.label)}</div>
                <div className="crm-stat__value">{num(card.value)}</div>
                <div className="crm-stat__hint text-truncate">{card.raw_hint ? card.hint : t(card.hint)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  /* ========================================== render : แถบสถานะ (กดเพื่อกรอง) */
  renderStages = () => {
    const { summary, applied } = this.state;
    const countOf = (value) => summary.status?.[value] || 0;
    const max = Math.max(1, ...PARTNER_STATUSES.map((meta) => countOf(meta.value)));

    return (
      <div className="prop-card prop-in mb-3">
        <div className="prop-card__head py-3">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("partner_flow_title")}
          </span>
          {applied.status ? (
            <button type="button" className="prop-link" onClick={() => this.toggleStatus(applied.status)}>
              <span className="icon text-12">{""}</span>
              {t("show_all_status")}
            </button>
          ) : (
            <span className="text-secondary text-12">{t("partner_flow_hint")}</span>
          )}
        </div>
        <div className="crm-pipeline">
          {PARTNER_STATUSES.map((meta, i) => {
            const active = applied.status === meta.value;
            const count = countOf(meta.value);
            return (
              <button
                key={meta.value}
                type="button"
                className={`crm-stage ${i === PARTNER_STATUSES.length - 1 ? "crm-stage--end" : ""} ${active ? "is-active" : ""}`}
                style={active ? { background: meta.tint } : undefined}
                onClick={() => this.toggleStatus(meta.value)}
              >
                <div className="crm-stage__top">
                  <span className="crm-stage__icon icon" style={{ backgroundColor: meta.tint, color: meta.tone }}>
                    {meta.icon}
                  </span>
                  <span className="crm-stage__label">{t(meta.label)}</span>
                </div>
                <div>
                  <span className="crm-stage__value">{num(count)}</span>
                  <span className="crm-stage__unit">{t("partner_unit")}</span>
                </div>
                <div className="crm-stage__track">
                  <div
                    className="crm-stage__fill"
                    style={{ width: `${Math.round((count / max) * 100)}%`, backgroundColor: meta.tone, minWidth: count ? "6px" : 0 }}
                  />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  /* ==================================================== render : ตัวกรอง */
  renderFilter = () => {
    const { filter } = this.state;
    const { provinceOptions } = zoneOptions("", "");

    const select = (key, options) => (
      <Select
        className="prop-field prop-select"
        default={false}
        placeholder={t("all")}
        value={filter[key]}
        options={[{ value: "", label: t("all") }, ...options]}
        onChange={(value) => this.setFilter({ [key]: value })}
      />
    );

    return (
      <div className="prop-card prop-in mb-3">
        <div className="prop-card__head py-3">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            <span className="icon me-1 text-12">{""}</span>
            {t("search_filters")}
          </span>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.clearFilters}>
            <span className="icon text-12">{""}</span>
            {t("clear_filters")}
          </button>
        </div>

        <div className="p-4">
          <div className="row g-3">
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("partner_search")}</label>
              <div className="position-relative">
                <span className="icon prop-field-icon">{""}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("partner_search_placeholder")}
                  value={filter.keyword}
                  onChange={(e) => this.setFilter({ keyword: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("status")}</label>
              {select("status", PARTNER_STATUSES.map((s) => ({ value: s.value, label: t(s.label) })))}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("partner_experience_level")}</label>
              {select("experience", EXPERIENCE_OPTIONS.map((e) => ({ value: e.value, label: t(e.label) })))}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("partner_doc_type")}</label>
              {select("doc_type", DOC_TYPES.map((d) => ({ value: d.value, label: t(d.label) })))}
            </div>

            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("partner_province")}</label>
              {select("province", provinceOptions)}
            </div>

            {/* prop-datefield ยกปฏิทินให้ลอยเหนือฟิลด์อื่นในแถวเดียวกัน */}
            <div className="col-xl-3 col-md-6 prop-datefield">
              <label className="prop-label">{t("partner_submitted_date")}</label>
              <DateRangePicker
                type="th"
                className="prop-field"
                value={filter.submitted}
                onChange={(value) => this.setFilter({ submitted: value })}
              />
            </div>

            <div className="col-xl-6 col-md-12 d-flex align-items-end justify-content-end">
              <button type="button" className="prop-btn" onClick={() => this.Get(1)}>
                <span className="icon text-14">{""}</span>
                {t("search")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================= render : แถบผลการค้นหา */
  renderToolbar = () => {
    const { count, sort } = this.state;
    return (
      <div className="prop-card prop-in p-3 mb-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div>
            <span className="fw-bold text-dark">{t("search_results")}</span>
            <span className="fw-bold ms-2" style={{ color: "#4d7c0f" }}>{num(count)}</span>
            <span className="text-secondary text-12 ms-1">{t("partner_unit")}</span>
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2">
            <span className="text-secondary text-12">{t("sort_by")}</span>
            <Select
              className="prop-field prop-select wpx-220"
              default={false}
              placeholder={t("sort_by")}
              value={sort}
              options={SORTS.map((s) => ({ value: s.value, label: t(s.label) }))}
              onChange={(value) => value && this.Get(1, this.state.applied, value)}
            />
          </div>
        </div>
      </div>
    );
  };

  /* ป้ายสถานะ — ใช้ทั้งในตารางและในกล่องรายละเอียด */
  renderBadge = (status) => {
    const meta = statusMeta(status);
    return (
      <span className="ppl-pill" style={{ backgroundColor: meta.tint, color: meta.tone }}>
        <span className="icon text-10 me-1">{meta.icon}</span>
        {t(meta.label)}
      </span>
    );
  };

  /* ===================================================== render : ตาราง */
  renderTable = () => {
    const { data } = this.state;

    return (
      <div className="prop-card prop-in">
        <div className="table-responsive" style={{ borderRadius: "18px" }}>
          <table className="ppl-table" style={{ minWidth: "1180px" }}>
            <thead>
              <tr>
                <th style={{ width: "252px" }}>{t("partner_col_applicant")}</th>
                <th style={{ width: "196px" }}>{t("contact")}</th>
                <th style={{ width: "208px" }}>{t("partner_col_experience")}</th>
                <th style={{ width: "150px" }}>{t("datetime")}</th>
                <th style={{ width: "170px" }}>{t("status")}</th>
                <th className="text-center" style={{ width: "148px" }}>{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => {
                const expertise = (item.expertise || [])
                  .map((value) => optionLabel(EXPERTISE_OPTIONS, value, t))
                  .filter(Boolean);

                const expertiseText = expertise.length ? expertise.join(" · ") : t("partner_no_expertise");

                return (
                  <tr key={item.uid}>
                    {/* ผู้สมัคร : รูปย่อ + ชื่อ + เลขที่ใบสมัคร */}
                    <td>
                      <div className="d-flex align-items-center gap-3">
                        <div className="ppl-avatar" style={{ background: avatarTone(item.full_name) }}>
                          {initials(item.full_name)}
                        </div>
                        <div className="min-w-0">
                          <div className="ppl-name text-truncate">{item.full_name}</div>
                          <div className="ppl-sub text-truncate">{item.code}</div>
                        </div>
                      </div>
                    </td>

                    {/* ติดต่อ : อีเมล (พร้อมป้ายว่ายืนยันแล้ว) + เบอร์ */}
                    <td>
                      <div className="d-flex align-items-center gap-1 text-truncate">
                        <span className="text-truncate">{item.email}</span>
                        {item.email_verified && (
                          <span className="icon text-10 text-success" title={t("partner_email_verified")}>
                            {""}
                          </span>
                        )}
                      </div>
                      <div className="ppl-sub">{fmtPhone(item.phone)}</div>
                    </td>

                    {/* ประสบการณ์ + ความถนัด
                        ตารางเป็น table-layout อัตโนมัติ ความกว้างที่ตั้งไว้ที่ <th> เป็นแค่คำใบ้
                        เซลล์จึงยืดตามข้อความจนคอลัมน์อื่นโดนบีบ ต้องล็อกความกว้างที่ตัว div
                        (208px ของหัวคอลัมน์ ลบ padding ซ้าย-ขวาอีก 32px) แล้ว text-truncate
                        ถึงจะตัดเป็น ... ให้จริง ส่วนข้อความเต็มอ่านได้จาก tooltip */}
                    <td>
                      <div className="text-truncate" style={{ maxWidth: "176px" }}>
                        {optionLabel(EXPERIENCE_OPTIONS, item.experience, t) || "-"}
                      </div>
                      <div className="ppl-sub text-truncate" style={{ maxWidth: "176px" }} title={expertiseText}>
                        {expertiseText}
                      </div>
                    </td>

                    {/* วันที่-เวลาที่ส่งใบสมัคร */}
                    <td>
                      <div className="text-truncate">{dateText(item.submitted_at)}</div>
                      <div className="ppl-sub">{timeText(item.submitted_at)}</div>
                    </td>

                    {/* สถานะ + บัญชีที่ออกให้ (ถ้ามี) */}
                    <td>
                      {this.renderBadge(item.status)}
                      {!!item.account && (
                        <div className={`ppl-sub mt-1 ${item.account.is_active ? "text-success" : "text-danger"}`}>
                          <span className="icon text-10 me-1">{""}</span>
                          {item.account.is_active ? t("partner_account_active") : t("partner_account_disabled")}
                        </div>
                      )}
                    </td>

                    {/* จัดการ */}
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          type="button"
                          className="prop-iconbtn prop-iconbtn--dark icon"
                          title={t("view_detail")}
                          onClick={() => this.OpenView(item)}
                        >
                          {""}
                        </button>
                        {can("partners.approve") && !DECIDED_STATUSES.includes(item.status) && (
                          <button
                            type="button"
                            className="prop-iconbtn icon"
                            title={t("check")}
                            onClick={() => this.OpenReview(item)}
                          >
                            {""}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}

              {!data.length && (
                <tr>
                  <td colSpan={6}>
                    <div className="prop-empty">
                      <div className="prop-empty__icon icon">{""}</div>
                      <div className="fw-bold text-dark mb-1">{t("partner_empty_title")}</div>
                      <div className="text-12">{t("partner_empty_desc")}</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* ============================================= render : ชิ้นส่วนที่ใช้ร่วมกัน */
  /* กล่อง "ดูรายละเอียด" กับ "ตรวจสอบใบสมัคร" แสดงข้อมูลชุดเดียวกัน ต่างกันแค่ปุ่ม
     ท้ายกล่อง จึงวาดหัวกล่องและเนื้อในจากชุดเดียวกัน แก้ที่เดียวเปลี่ยนพร้อมกันทั้งคู่ */

  /* หัวกล่อง : ตัวตนของใบสมัคร — อ่านครั้งเดียวรู้ว่ากำลังดูใบไหนของใคร สถานะอะไร */
  renderHero = (detail) => (
    <div className="pnr-hero">
      {/* มีรูปที่ผู้สมัครแนบมาก็ใช้รูปจริง — ตัวอักษรย่อเป็นของสำรองสำหรับใบที่ไม่ได้แนบ
          (รูปไม่บังคับ และใบเก่าก่อนมีช่องนี้ก็ไม่มีรูป) */}
      <div className="pnr-hero__avatar" style={{ background: avatarTone(detail.full_name) }}>
        {detail.picture ? (
          <img className="pnr-hero__photo" src={detail.picture} alt="" />
        ) : (
          initials(detail.full_name)
        )}
      </div>
      <div className="min-w-0 flex-grow-1">
        <div className="pnr-hero__name text-truncate">{detail.full_name}</div>
        <div className="pnr-hero__meta">
          <span className="pnr-code">{detail.code}</span>
          <span className="pnr-hero__dot" />
          <span>
            {t("partner_submitted_at")} {dateTimeText(detail.submitted_at)}
          </span>
        </div>
      </div>
      <div className="flex-shrink-0">{this.renderBadge(detail.status)}</div>
    </div>
  );

  /* แถวข้อมูล — label ความกว้างคงที่ทุกหมวด ค่าจึงเรียงตรงเป็นคอลัมน์เดียวกันทั้งกล่อง
     ค่าที่ไม่มีโชว์ขีดกลางสีจาง ไม่ปล่อยว่างจนดูเหมือนหน้าจอโหลดไม่ครบ */
  detailRow = (key, label, value, strong) => (
    <div className="pnr-row" key={key}>
      <div className="pnr-row__label">{label}</div>
      <div className={`pnr-row__value${value ? "" : " pnr-row__value--empty"}${strong ? " pnr-strong" : ""}`}>
        {value || "-"}
      </div>
    </div>
  );

  detailSection = (icon, title, children, note) => (
    <div className="pnr-sec">
      <div className="pnr-sec__head">
        <span className="pnr-sec__icon icon">{icon}</span>
        <span className="pnr-sec__title">{title}</span>
        {!!note && <span className="pnr-sec__note">{note}</span>}
      </div>
      {children}
    </div>
  );

  /* หลักฐานความยินยอม — เก็บเป็นเวลาที่กดยอมรับ ไม่ใช่แค่ true/false เพราะ PDPA
     ต้องพิสูจน์ได้ว่ายินยอมเมื่อไหร่ จึงโชว์เวลาคู่กับเครื่องหมายถูกเสมอ */
  consentRow = (key, label, on, at) => (
    <div className="pnr-check" key={key}>
      <span className={`pnr-check__mark icon${on ? "" : " pnr-check__mark--off"}`}>{on ? "" : ""}</span>
      <span className="pnr-check__label">{label}</span>
      <span className="pnr-check__time">{on ? dateTimeText(at) : t("partner_consent_pending")}</span>
    </div>
  );

  /* เนื้อในของกล่อง : ข้อมูลผู้สมัคร เอกสาร บัญชี และประวัติการพิจารณา */
  renderDetailBody = (detail) => {
    const { preview } = this.state;

    const expertise = (detail.expertise || [])
      .map((value) => optionLabel(EXPERTISE_OPTIONS, value, t))
      .filter(Boolean);

    const docs = detail.documents || [];

    return (
      <>
        {/* ไม่อนุมัติ/ระงับแล้วต้องเห็นเหตุผลก่อนอย่างอื่น — คนที่เปิดกล่องนี้มักเปิดมา
            เพราะผู้สมัครโทรมาถามว่าทำไม */}
        {!!detail.reject_reason && (
          <div className="pnr-note pnr-note--danger mb-3">
            <span className="icon">{""}</span>
            <div className="min-w-0">
              <div className="pnr-note__title">{t(statusMeta(detail.status).label)}</div>
              <div className="mt-1">{detail.reject_reason}</div>
            </div>
          </div>
        )}

        <div className="row g-3">
          <div className="col-lg-7">
            {this.detailSection(
              "",
              t("partner_section_personal"),
              <>
                {this.detailRow(
                  "email",
                  t("partner_email"),
                  <>
                    {detail.email}
                    {detail.email_verified && (
                      <span className="pnr-pill pnr-pill--ghost ms-2">
                        <span className="icon text-10" style={{ color: "#15803d" }}>
                          {""}
                        </span>
                        {t("partner_email_verified")}
                      </span>
                    )}
                  </>
                )}
                {this.detailRow("phone", t("partner_phone"), fmtPhone(detail.phone))}
                {this.detailRow(
                  "line",
                  t("partner_line"),
                  detail.line_id ? (
                    <a href={lineAddUrl(detail.line_id)} target="_blank" rel="noreferrer">
                      {detail.line_id}
                    </a>
                  ) : (
                    ""
                  )
                )}
                {this.detailRow("address", t("partner_address"), fullAddress(detail))}
                {/* รูปโปรไฟล์ที่ผู้สมัครแนบมา — กดขยายได้ด้วยกล่องเดียวกับเอกสารยืนยันตัวตน
                    (ในหัวกล่องมีอยู่แล้วแต่เล็กแค่ 54px ดูหน้าคนไม่ชัดพอจะเทียบกับบัตร) */}
                {this.detailRow(
                  "picture",
                  t("partner_picture"),
                  detail.picture ? (
                    <button
                      type="button"
                      className="pnr-avatar-view"
                      title={t("partner_doc_zoom")}
                      onClick={() => this.setState({ preview: { file_path: detail.picture } })}
                    >
                      <img src={detail.picture} alt="" />
                    </button>
                  ) : (
                    ""
                  )
                )}
              </>
            )}

            {this.detailSection(
              "",
              t("partner_section_experience"),
              <>
                {this.detailRow(
                  "exp",
                  t("partner_experience_level"),
                  optionLabel(EXPERIENCE_OPTIONS, detail.experience, t),
                  true
                )}
                {this.detailRow("license", t("partner_license"), detail.license_no)}
                {this.detailRow(
                  "expertise",
                  t("partner_expertise"),
                  expertise.length ? (
                    <span className="d-flex flex-wrap gap-1">
                      {expertise.map((label) => (
                        <span key={label} className="pnr-chip">
                          {label}
                        </span>
                      ))}
                    </span>
                  ) : (
                    ""
                  )
                )}
                {this.detailRow("about", t("partner_about"), detail.about)}
              </>
            )}

            {this.detailSection(
              "",
              t("partner_section_consent"),
              <>
                {this.consentRow("terms", t("partner_consent_terms"), !!detail.accept_terms, detail.accept_terms_at)}
                {this.consentRow("pdpa", t("partner_consent_pdpa"), !!detail.accept_pdpa, detail.accept_pdpa_at)}
                {this.consentRow("email", t("partner_consent_email"), !!detail.email_verified, detail.email_verified_at)}
              </>
            )}
          </div>

          <div className="col-lg-5">
            {/* เอกสารยืนยันตัวตน — กดที่รูปเพื่อขยายดูเต็ม (เลขบัตรตัวเล็กมาก อ่านจากรูปย่อไม่ออก) */}
            {this.detailSection(
              "",
              t("partner_section_doc"),
              docs.length ? (
                <div className="pnr-docs">
                  {docs.map((doc) => (
                    <div key={doc.uid} className="pnr-doc">
                      {isImageDoc(doc) ? (
                        <button
                          type="button"
                          className="pnr-doc__thumb"
                          title={t("partner_doc_zoom")}
                          onClick={() => this.setState({ preview: doc })}
                        >
                          <img src={doc.file_path} alt="" />
                          <span className="pnr-doc__zoom icon">{""}</span>
                        </button>
                      ) : (
                        <div className="pnr-doc__thumb icon">{""}</div>
                      )}
                      <div className="pnr-doc__foot">
                        <div className="min-w-0 flex-grow-1">
                          <div className="pnr-doc__name text-truncate">
                            {doc.file_name || t("partner_doc_unnamed")}
                          </div>
                          <div className="pnr-doc__size">{fileSize(doc.file_size)}</div>
                        </div>
                        <a
                          className="pnr-doc__open icon"
                          href={doc.file_path}
                          target="_blank"
                          rel="noreferrer"
                          title={t("partner_doc_open")}
                        >
                          {""}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="pnr-empty">{t("partner_no_document")}</div>
              ),
              docs.length
                ? `${optionLabel(DOC_TYPES, detail.doc_type, t)} · ${num(docs.length)} ${t("partner_doc_unit")}`
                : ""
            )}

            {/* บัญชีเข้าใช้งาน — มีก็ต่อเมื่ออนุมัติไปแล้ว */}
            {this.detailSection(
              "",
              t("partner_section_account"),
              detail.account ? (
                <>
                  {this.detailRow("user_code", t("user_code"), detail.account.user_code, true)}
                  {this.detailRow(
                    "account_status",
                    t("status"),
                    <span
                      className="pnr-pill"
                      style={
                        detail.account.is_active
                          ? { background: "#dcfce7", color: "#15803d" }
                          : { background: "#e7e5e4", color: "#57534e" }
                      }
                    >
                      {detail.account.is_active ? t("partner_account_active") : t("partner_account_disabled")}
                    </span>
                  )}
                  {this.detailRow(
                    "last_login",
                    t("partner_last_login"),
                    detail.account.last_login_at ? dateTimeText(detail.account.last_login_at) : ""
                  )}
                </>
              ) : (
                <div className="pnr-empty">{t("partner_no_account")}</div>
              )
            )}

            {/* บัญชีรับเงิน — ทีมการเงินใช้ตอนโอนค่าคอมมิชชั่น อยู่แยกกล่องของตัวเองเพราะ
                เป็นข้อมูลที่ต้องอ่านทีละตัวอักษรตอนคีย์โอน ไม่ใช่กวาดตาผ่าน */}
            {this.detailSection(
              "",
              t("partner_section_bank"),
              <>
                {this.detailRow("bank", t("partner_bank"), detail.bank ? bankLabel(detail.bank, isTh()) : "")}
                {this.detailRow("bank_no", t("partner_account_no"), detail.bank_account_no, true)}
                {this.detailRow("bank_name", t("partner_account_name"), detail.bank_account_name)}
              </>
            )}

            {this.detailSection(
              "",
              t("partner_section_history"),
              <>
                {this.detailRow("reviewer", t("partner_reviewer"), detail.reviewer?.full_name)}
                {this.detailRow(
                  "reviewed_at",
                  t("partner_reviewed_at"),
                  detail.reviewed_at ? dateTimeText(detail.reviewed_at) : ""
                )}
                {this.detailRow("note", t("partner_internal_note"), detail.note)}
              </>
            )}
          </div>
        </div>

        {/* รูปเอกสารที่กดขยาย — ทับอยู่ในกล่องเดิม ไม่เปิดกล่องซ้อนกล่อง */}
        {!!preview && (
          <button type="button" className="pnr-zoom" onClick={() => this.setState({ preview: null })}>
            <img src={preview.file_path} alt="" />
          </button>
        )}
      </>
    );
  };

  /* ============================================== render : กล่องรายละเอียด */
  renderViewModal = () => {
    const { modal_view, detail } = this.state;
    if (!modal_view || !detail) return null;

    return (
      <Modal size="xl" show={modal_view} onHide={this.CloseView} centered contentClassName="pnr-modal">
        {this.renderHero(detail)}

        <Modal.Body className="pnr-body">{this.renderDetailBody(detail)}</Modal.Body>

        <div className="pnr-foot">
          <div className="pnr-foot__actions">
            <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseView}>
              {t("close")}
            </button>
          </div>
        </div>
      </Modal>
    );
  };


  /* ============================================== render : กล่องแก้ไขข้อมูล */
  renderFormModal = () => {
    const { modal_form, form } = this.state;
    const { provinceOptions, districtOptions, subdistrictOptions } = zoneOptions(form.province, form.district);

    return (
      <Modal
        size="lg"
        show={modal_form}
        onHide={this.CloseForm}
        centered
        contentClassName="border-0 rounded-4 overflow-visible shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <div className="fw-bold text-dark text-16">{t("partner_edit_title")}</div>
            <div className="text-secondary text-12">{t("partner_edit_desc")}</div>
          </div>
          <button type="button" className="prop-iconbtn icon" onClick={this.CloseForm}>{""}</button>
        </Modal.Header>

        <Modal.Body className="px-4 py-3 bg-white">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="prop-label">
                {t("partner_name")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                value={form.full_name}
                onChange={(e) => this.setForm({ full_name: e.target.value })}
              />
            </div>
            <div className="col-md-3">
              <label className="prop-label">{t("partner_phone")}</label>
              <input
                type="tel"
                inputMode="numeric"
                maxLength={10}
                className="prop-field"
                value={form.phone}
                onChange={(e) => this.setForm({ phone: e.target.value.replace(/[^0-9]/g, "") })}
              />
            </div>
            <div className="col-md-3">
              <label className="prop-label">{t("partner_line")}</label>
              <input
                type="text"
                className="prop-field"
                value={form.line_id}
                onChange={(e) => this.setForm({ line_id: e.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("partner_address")}</label>
              <input
                type="text"
                className="prop-field"
                value={form.address}
                onChange={(e) => this.setForm({ address: e.target.value })}
              />
            </div>

            <div className="col-md-3">
              <label className="prop-label">{t("partner_province")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("partner_select_placeholder")}
                value={form.province}
                options={provinceOptions}
                onChange={this.setProvince}
              />
            </div>
            <div className="col-md-3">
              <label className="prop-label">{t("partner_district")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("partner_select_placeholder")}
                value={form.district}
                options={districtOptions}
                disabled={!form.province}
                onChange={this.setDistrict}
              />
            </div>
            <div className="col-md-3">
              <label className="prop-label">{t("partner_subdistrict")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("partner_select_placeholder")}
                value={form.subdistrict}
                options={subdistrictOptions}
                disabled={!form.district}
                onChange={this.setSubdistrict}
              />
            </div>
            <div className="col-md-3">
              <label className="prop-label">{t("partner_postcode")}</label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={5}
                className="prop-field"
                value={form.postcode}
                onChange={(e) => this.setForm({ postcode: e.target.value.replace(/[^0-9]/g, "") })}
              />
            </div>

            {/* บัญชีรับเงิน — เปิดให้แก้ด้วยเหตุผลเดียวกับเบอร์/ที่อยู่ คือผู้สมัครคีย์ผิด
                แล้วโทรมาบอกทีหลัง เลขบัญชีผิดตัวเดียวเงินก็ไปไม่ถึง */}
            <div className="col-md-5">
              <label className="prop-label">{t("partner_bank")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("partner_select_placeholder")}
                value={form.bank}
                /* front = โลโก้ธนาคาร ชุดเดียวกับหน้าตั้งค่าเหรียญและฟอร์มใบสมัคร
                   ธนาคารที่ยังไม่มีไฟล์โลโก้ให้ปล่อยว่าง ไม่ใส่ <img src=""> */
                options={(global.bank || []).map((item) => {
                  const logo = bankLogo(item.value);
                  return {
                    value: item.value,
                    label: isTh() ? item.name_th : item.label,
                    front: logo ? <img className="set-bank__logo" src={logo} alt="" /> : null,
                  };
                })}
                onChange={(value) => this.setForm({ bank: value || "" })}
              />
            </div>
            <div className="col-md-3">
              <label className="prop-label">{t("partner_account_no")}</label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={30}
                className="prop-field"
                placeholder="123-4-56789-0"
                value={form.bank_account_no}
                // รับเฉพาะตัวเลขกับขีด เหมือนช่องเดียวกันในฟอร์มใบสมัคร
                onChange={(e) => this.setForm({ bank_account_no: e.target.value.replace(/[^0-9-]/g, "") })}
              />
            </div>
            <div className="col-md-4">
              <label className="prop-label">{t("partner_account_name")}</label>
              <input
                type="text"
                maxLength={150}
                className="prop-field"
                value={form.bank_account_name}
                onChange={(e) => this.setForm({ bank_account_name: e.target.value })}
              />
            </div>

            <div className="col-md-4">
              <label className="prop-label">{t("partner_experience_level")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("partner_select_placeholder")}
                value={form.experience}
                options={EXPERIENCE_OPTIONS.map((e) => ({ value: e.value, label: t(e.label) }))}
                onChange={(value) => this.setForm({ experience: value })}
              />
            </div>
            <div className="col-md-4">
              <label className="prop-label">{t("partner_license")}</label>
              <input
                type="text"
                className="prop-field"
                value={form.license_no}
                onChange={(e) => this.setForm({ license_no: e.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("partner_expertise")}</label>
              <div className="prop-seg flex-wrap">
                {EXPERTISE_OPTIONS.map((item) => {
                  const on = (form.expertise || []).includes(item.value);
                  return (
                    <button
                      key={item.value}
                      type="button"
                      aria-pressed={on}
                      className={`prop-seg__btn ${on ? "is-active" : "bg-white"}`}
                      onClick={() => this.toggleExpertise(item.value)}
                    >
                      {t(item.label)}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("partner_about")}</label>
              <textarea
                className="prop-field"
                rows={3}
                maxLength={500}
                value={form.about}
                onChange={(e) => this.setForm({ about: e.target.value })}
              />
            </div>

            {/* โน้ตภายใน — ผู้สมัครไม่เห็น ใช้บันทึกสิ่งที่ตรวจเจอระหว่างพิจารณา */}
            <div className="col-12">
              <label className="prop-label">{t("partner_internal_note")}</label>
              <textarea
                className="prop-field"
                rows={3}
                maxLength={2000}
                placeholder={t("partner_internal_note_placeholder")}
                value={form.note}
                onChange={(e) => this.setForm({ note: e.target.value })}
              />
            </div>
          </div>

          <div className="ppl-note mt-4">
            <span className="icon">{""}</span>
            <div>{t("partner_edit_hint")}</div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.Save}>
            <span className="icon text-12">{""}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  /* ======================================= render : กล่องตรวจสอบใบสมัคร */
  /* เลือกสถานะถัดไปได้ทุกทางที่ STATUS_TRANSITIONS อนุญาต (ชุดเดียวกับ backend)
     ผู้ใช้จึงไม่เห็นตัวเลือกที่กดแล้วโดนปฏิเสธ และไม่ต้องจำเองว่าจากสถานะนี้ไปไหนได้

     เลือกก่อน-ยืนยันทีหลัง : ผลบางอย่างย้อนกลับไม่ได้ (ไม่อนุมัติ) และบางอย่างต้อง
     กรอกเหตุผลที่ผู้สมัครจะได้เห็น จึงไม่ให้จบในปุ่มเดียว */
  renderReviewModal = () => {
    const { modal_review, detail, review } = this.state;
    if (!modal_review || !detail) return null;

    const choices = STATUS_TRANSITIONS[detail.status] || [];
    const needReason = REASON_REQUIRED_STATUSES.includes(review.to);
    const meta = review.to ? actionMeta(detail.status, review.to) : null;

    /* ยืนยันได้ต่อเมื่อเลือกสถานะแล้ว และกรอกเหตุผลครบถ้าสถานะนั้นบังคับ */
    const ready = !!review.to && (!needReason || !!review.reason.trim());

    return (
      <Modal size="xl" show={modal_review} onHide={this.CloseReview} centered contentClassName="pnr-modal">
        {this.renderHero(detail)}

        <Modal.Body className="pnr-body">
          <div className="pnr-sec pnr-sec--decide mb-3">
            <div className="pnr-sec__head">
              <span className="pnr-sec__icon icon">{""}</span>
              <span className="pnr-sec__title">{t("partner_decision_title")}</span>
              <span className="pnr-sec__note d-flex align-items-center gap-2">
                {t("partner_current_status")}
                {this.renderBadge(detail.status)}
              </span>
            </div>

            {choices.length ? (
              <>
                <div className="pnr-picks">
                  {choices.map((to) => {
                    const pick = actionMeta(detail.status, to);
                    const tone = statusMeta(to);
                    const danger = REASON_REQUIRED_STATUSES.includes(to);
                    const on = review.to === to;

                    return (
                      <button
                        key={to}
                        type="button"
                        aria-pressed={on}
                        className={`pnr-pick${on ? " is-active" : ""}${danger ? " pnr-pick--danger" : ""}`}
                        onClick={() => this.setReview({ to, reason: "" })}
                      >
                        <span
                          className="pnr-pick__icon icon"
                          style={{ background: tone.tint, color: tone.tone }}
                        >
                          {pick.icon}
                        </span>
                        <span className="pnr-pick__body">
                          <span className="pnr-pick__label">{t(pick.label)}</span>
                          <span className="pnr-pick__desc">{t(pickHint(detail.status, to))}</span>
                        </span>
                        <span className="pnr-pick__mark icon">{""}</span>
                      </button>
                    );
                  })}
                </div>

                {/* เหตุผลบังคับเฉพาะ ไม่อนุมัติ / ระงับ — ผู้สมัครจะได้เห็นข้อความนี้
                    และทีมที่รับสายต่อใช้ตอบได้โดยไม่ต้องตามหาคนที่กดปุ่ม */}
                {needReason && (
                  <div className="pnr-reason mt-3">
                    <div className="pnr-reason__head">
                      <span className="pnr-reason__icon icon">{""}</span>
                      <span className="pnr-reason__title">
                        {t("partner_reason")} {t(meta.label)}
                      </span>
                      <span className="pnr-reason__count">{(review.reason || "").length}/1000</span>
                    </div>
                    <textarea
                      className="prop-field"
                      rows={3}
                      maxLength={1000}
                      autoFocus
                      placeholder={t("partner_reason_placeholder")}
                      value={review.reason}
                      onChange={(e) => this.setReview({ reason: e.target.value })}
                    />
                    <div className="text-secondary text-12 mt-2">{t("partner_reason_hint")}</div>
                  </div>
                )}

                {/* ผลที่กระทบบัญชีเข้าใช้งานจริง ต้องบอกให้ชัดตั้งแต่ก่อนกดยืนยัน */}
                {review.to === "approved" && (
                  <div className="pnr-note pnr-note--info mt-3">
                    <span className="icon">{""}</span>
                    <div>{t("partner_approve_hint")}</div>
                  </div>
                )}
                {review.to === "suspended" && (
                  <div className="pnr-note pnr-note--danger mt-3">
                    <span className="icon">{""}</span>
                    <div>{t("partner_suspend_hint")}</div>
                  </div>
                )}
              </>
            ) : (
              <div className="pnr-note pnr-note--danger">
                <span className="icon">{""}</span>
                <div>{t("partner_no_decision")}</div>
              </div>
            )}
          </div>

          {this.renderDetailBody(detail)}
        </Modal.Body>

        <div className="pnr-foot">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseReview}>
            {t("close")}
          </button>

          {!!choices.length && (
            <div className="pnr-foot__actions">
              <button
                type="button"
                className={`prop-btn${needReason ? " pnr-btn--danger-solid" : ""}`}
                disabled={!ready}
                onClick={() => this.Review(review.to)}
              >
                {!!meta && <span className="icon text-12">{meta.icon}</span>}
                {meta ? t(meta.label) : t("partner_decision_pick")}
              </button>
            </div>
          )}
        </div>
      </Modal>
    );
  };

  render() {
    const { count, page } = this.state;
    const from = (page - 1) * PAGE_SIZE + 1;
    const to = Math.min(page * PAGE_SIZE, count);

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("partners")}</h3>
              <div className="text-secondary text-14">{t("partner_page_desc")}</div>
            </div>
            {/* ไม่มีปุ่มเพิ่ม — ใบสมัครเกิดจากหน้าเว็บสาธารณะเท่านั้น (ดูหมายเหตุหัวไฟล์)
                ปุ่มนี้จึงเป็นทางไปดูฟอร์มที่ผู้สมัครเห็นแทน */}
            <a className="prop-btn prop-btn--ghost" href="/partner" target="_blank" rel="noreferrer">
              <span className="icon text-14">{""}</span>
              {t("partner_view_form")}
            </a>
          </div>

          {this.renderSummary()}
          {this.renderStages()}
          {this.renderFilter()}
          {this.renderToolbar()}
          {this.renderTable()}

          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
            <div>
              {t("showing")} {from}-{to} {t("of")} {num(count)} {t("partner_unit")}
            </div>
            <Pagination
              className="mb-0"
              page={page}
              count={Math.ceil(count / PAGE_SIZE) || 1}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, next) => {
                this.Get(next, this.state.applied);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </div>
        </div>

        {this.renderViewModal()}
        {this.renderFormModal()}
        {this.renderReviewModal()}
      </div>
    );
  }
}
